import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;

// PUT: Disables a company - protected route
async function httpDisableCompany(id) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/actions/disable/${id}`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
}

// PUT: Activates a company - protected route
async function httpActivateCompany(id) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/actions/activate/${id}`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
}

// PUT: Unassign a user from a company
async function httpRemoveUserFromCompany(userId, companyId) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/employees/unassign-user/${userId}`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({ companyId }),
  });
}

// PUT: Archieves the form
async function httpToggleArchiveForm(id) {
  const token = Auth.getToken();
  try {
    let response = await fetch(`${API_URL}/companies/forms/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return await response.json();
  } catch (err) {
    return err;
  }
}

// PUT: Marks a comment as seen by a user
async function httpMarkCommentAsSeen(formInstanceId, unseenCommentIds, userId) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/companies/comments/seen`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({ formInstanceId, unseenCommentIds, userId }),
  });
}

// PUT: Toggle flag on a form instance
async function httpToggleFlagFormInstance(formId, userId) {
  const token = Auth.getToken();

  let res = await fetch(`${API_URL}/companies/forms/toggle-flag`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({ formId, userId }),
  });
  return await res.json();
}

export {
  httpActivateCompany,
  httpDisableCompany,
  httpRemoveUserFromCompany,
  httpToggleArchiveForm,
  httpMarkCommentAsSeen,
  httpToggleFlagFormInstance,
};
